import { createFileRoute } from "@tanstack/react-router";
import HerramientasParaRetail from "@/pages/HerramientasParaRetail";

const title = "Retail & hospitality tools | Retail Lemon";
const description = "Calculator, KPIs, grants, suppliers, in-store music and scent for your venue.";

/**
 * Ruta índice del hub EN (`/en/tools`). Vive como `tools.index.tsx` para que
 * NO sea layout de las herramientas hijas (`/en/tools/calculator`, ...) y
 * cada una renderice su página real.
 */
export const Route = createFileRoute("/en/tools/")({
  head: () => ({ meta: [
    { title },
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" },
  ] }),
  component: () => <HerramientasParaRetail routeLang="en" />,
});
